import { createGlobalStyle } from 'styled-components';
import theme from './theme';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');
  
  * {
    box-sizing: border-box;
  }
  
  body {
    margin: 0;
    padding: 0;
    font-family: ${theme.typography.fontFamily};
    background-color: ${theme.colors.background};
    color: ${theme.colors.text};
    overflow: hidden;
  }
  
  #root {
    height: 100vh;
    width: 100vw;
  }
  
  
  /* Scrollbar styling */
  ::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }
  
  ::-webkit-scrollbar-track {
    background: ${theme.colors.background};
    border-radius: 4px;
  }
  
  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.primaryDark};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${theme.colors.primary};
  }

  /* Firefox scrollbar */
  * {
    scrollbar-width: thin;
    scrollbar-color: ${theme.colors.primaryDark} ${theme.colors.background};
  }

  /* Focus styles */
  *:focus {
    outline: 2px solid ${theme.colors.primary};
    outline-offset: 2px;
  }
  
  /* Button focus styles */
  button:focus {
    outline: none;
  }
  
  /* Disable text selection on interactive elements */
  button, input, textarea {
    user-select: none;
  }
  
  /* Video element cursor override */
  video, .video-js, .video-wrapper, .vjs-tech {
    cursor: ${props => props.isPaused ? 'crosshair' : 'default'} !important;
  }
  
  /* Keep pointer for buttons */
  button, 
  input[type="button"], 
  input[type="submit"],
  .vjs-big-play-button {
    cursor: pointer !important;
  }
  
  /* Override any inline cursor styles on video elements */
  video[style*="cursor: grab"],
  video[style*="cursor: grabbing"],
  video[style*="cursor: move"],
  video[style*="cursor: hand"],
  .video-wrapper[style*="cursor: grab"],
  .video-wrapper[style*="cursor: grabbing"],
  .video-wrapper[style*="cursor: move"],
  .video-wrapper[style*="cursor: hand"] {
    cursor: ${props => props.isPaused ? 'crosshair' : 'default'} !important;
  }
`;

export default GlobalStyles; 